const DRAFT_EMAILS_KEY = 'email-drafts';
class DraftEmailHelper {
    getDrafts() {
        const savedDrafts = localStorage.getItem(DRAFT_EMAILS_KEY);
        if (!savedDrafts)
            return null;
        return JSON.parse(savedDrafts);
    }
    setDrafts(drafts) {
        localStorage.setItem(DRAFT_EMAILS_KEY, JSON.stringify(drafts));
    }
}
export default new DraftEmailHelper();
